import axios from 'axios';

const DATA_ATTR    = 'data-locations';
const CLASS_PREFIX = 'locations';

document.querySelectorAll(`[${DATA_ATTR}]`).forEach(initLocations);

export function initLocations(container) {
    const tpl        = container.querySelector(`[${DATA_ATTR}-location-card-template]`).content;
    const listEl     = container.querySelector(`[${DATA_ATTR}-list]`);
    const pagination = container.querySelector(`[${DATA_ATTR}-pagination]`);
    const loader     = container.querySelector(`[${DATA_ATTR}-loader]`);
    const citySelect = container.querySelector(`[${DATA_ATTR}-city-selector]`);

    let currentPage = 1;
    let lastPage    = 1;
    const perPage   = 12;
    let cityId      = '';

    citySelect.addEventListener('change', () => {
        cityId = citySelect.value;
        currentPage = 1;
        listEl.innerHTML = '';
        pagination.style.display = 'flex';
        loadPage();
    });

    pagination.addEventListener('click', () => {
        if (currentPage <= lastPage) {
            loadPage();
        }
    });

    loadPage();

    function loadPage() {
        loader.hidden = false;

        axios.get('/api/locations', {
            params: {
                page: currentPage,
                per_page: perPage,
                city_id: cityId,
            }
        })
            .then(response => {
                const { data, current_page, last_page } = response.data;
                lastPage = last_page;

                data.forEach(loc => {
                    const card = tpl.cloneNode(true);

                    // Заголовок
                    card.querySelector(`[${DATA_ATTR}-title]`).textContent = loc.title;

                    // Телефон
                    const phoneLink = card.querySelector(`[${DATA_ATTR}-phone]`);
                    if (loc.phone) {
                        phoneLink.textContent = loc.phone;
                        phoneLink.href = `tel:${loc.phone}`;
                    } else {
                        phoneLink.closest(`.${CLASS_PREFIX}__card-info-item`).remove();
                    }

                    // Email
                    const emailLink = card.querySelector(`[${DATA_ATTR}-email]`);
                    if (loc.email) {
                        emailLink.textContent = loc.email;
                        emailLink.href = `mailto:${loc.email}`;
                    } else {
                        emailLink.closest(`.${CLASS_PREFIX}__card-info-item`).remove();
                    }

                    // Адрес
                    const addrEl = card.querySelector(`[${DATA_ATTR}-address]`);
                    if (loc.address) {
                        addrEl.textContent = loc.address;
                    } else {
                        addrEl.closest(`.${CLASS_PREFIX}__card-info-item`).remove();
                    }

                    // Социальные ссылки
                    ['facebook', 'instagram', 'telegram'].forEach(net => {
                        const a = card.querySelector(`[${DATA_ATTR}-${net}]`);
                        const url = loc[`social_${net}`];
                        if (url) {
                            a.href = url;
                        } else {
                            a.remove();
                        }
                    });

                    // Карта
                    const mapContainer = card.querySelector(`[${DATA_ATTR}-map]`);
                    if (loc.map) {
                        mapContainer.innerHTML = loc.map;
                    } else {
                        mapContainer.remove();
                    }

                    listEl.appendChild(card);
                });

                currentPage = current_page + 1;
                loader.hidden = true;

                if (currentPage > lastPage) {
                    pagination.style.display = 'none';
                }
            })
            .catch(error => {
                console.error('Error loading locations:', error);
                loader.hidden = true;
            });
    }
}
